module.exports = __webpack_public_path__ + "img/LAB.107e5e9b.jpg";